var _rect, _rect2, _rect3, _rect4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcMicrosoft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 21 21",
    width: 32,
    height: 32,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 9,
    height: 9,
    fill: "#F25022"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 1,
    width: 9,
    height: 9,
    fill: "#7FBA00"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 11,
    width: 9,
    height: 9,
    fill: "#00A4EF"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 11,
    width: 9,
    height: 9,
    fill: "#FFB900"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcMicrosoft);
export default __webpack_public_path__ + "static/media/ic_microsoft.3c34b67cadaaa5c19dd67d34964c55c4.svg";
export { ForwardRef as ReactComponent };